export const articles = [
  {
    id: 'article-1',
    title: '2026年最值得收藏的50个免费设计资源网站',
    slug: 'top-50-free-design-resources-2026',
    excerpt: '精心整理了2026年最新最全的免费设计资源网站，涵盖图标、字体、插画、UI组件等，设计师必备收藏清单。',
    content: `在数字化时代，优秀的设计资源往往价格不菲。但对于预算有限的独立设计师、创业者和学生来说，免费且高质量的设计资源同样能帮助你创作出专业水准的作品。

## 为什么选择免费设计资源

免费不等于低质量。许多顶级公司和开源社区都在积极贡献高质量的免费设计资源。这些资源不仅能够降低创作成本，还能让你接触到不同风格和设计理念。

## 图标资源推荐

### 1. Remix Icon
由Remix团队维护的开源图标库，包含超过2500个精美线性图标，风格统一，支持SVG和字体图标两种使用方式。

### 2. IconPark
字节跳动开源图标库，提供2400+个高质量图标，支持线框、填充、双色、多色四种风格，可在线调整参数。

### 3. Phosphor Icons
界面精美、风格多变的图标库，提供六种不同粗细风格的图标，非常适合现代UI设计使用。

## 字体资源推荐

### 4. Google Fonts
全球最大的免费字体库，收录上千款开源字体，支持中文、英文等多语言，直接在网页中引用即可使用。

### 5. 站酷免费字体
站酷平台推出的免费商用字体，包含站酷快乐体、站酷文艺体等多款中文字体，风格独特。

### 6. 阿里巴巴普惠体
阿里巴巴发布的免费商用字体，涵盖多种字重，适用于电商、品牌设计等多种场景。

## 插画资源推荐

### 7. unDraw
提供大量可自定义颜色的开源SVG插画，风格现代简约，适合网页和应用界面使用。

### 8. Storyset
Freepik旗下的免费插画平台，支持在线调整颜色和风格，可导出SVG、PNG等多种格式。

### 9. Blush
多样化的免费插画集合，支持自定义配色，风格丰富，适合不同场景使用。

## UI组件与模板

### 10. Tailwind UI 免费组件
Tailwind CSS官方提供的免费UI组件示例，代码精良，可直接用于项目开发。`,
    category: '设计素材',
    author: '资源导航编辑',
    publishDate: '2026-08-01',
    readTime: '8分钟',
    tags: ['设计资源', '免费工具', '资源合集'],
    imageSeq: 'article-design-resources',
  },
  {
    id: 'article-2',
    title: 'AI工具全面盘点：2026年最值得尝试的免费人工智能工具',
    slug: 'best-free-ai-tools-2026',
    excerpt: '从AI写作到AI绘画，从AI编程到AI数据分析，全面盘点2026年最值得尝试的免费AI工具，让你不花一分钱也能享受AI带来的效率革命。',
    content: `人工智能正在以前所未有的速度改变我们的工作和生活方式。2026年，越来越多强大的AI工具开始提供免费版本，让每个人都能体验到AI技术带来的便利。

## AI写作与对话工具

### ChatGPT
OpenAI推出的AI对话助手，免费版即可使用GPT-4o mini模型，能回答各类问题、撰写文章、翻译语言，是目前最受欢迎的AI工具之一。

### Claude
Anthropic开发的安全AI助手，免费版提供强大的文本处理能力，特别擅长长文分析和创作，上下文窗口高达200K。

### Gemini
谷歌推出的多模态AI模型，免费版支持文本、图片、代码等多种输入方式，与谷歌生态深度整合。

## AI绘画与图像工具

### Leonardo.AI
专注于游戏和创意领域的AI绘画工具，免费版每天提供一定额度，生成质量出众。

### Stable Diffusion
开源AI绘画模型，可本地免费运行，社区提供大量模型和插件，创作自由度极高。

### Remove.bg
AI智能抠图工具，免费版支持标准分辨率图片，处理速度快，效果精准。

## AI编程助手

### GitHub Copilot Free
GitHub推出的AI编程助手免费版，支持多种编程语言，可在VS Code等主流编辑器中使用。

### Codeium
完全免费的AI代码补全工具，支持70+种编程语言和40+种编辑器，是Copilot的有力竞争者。

### Cursor
基于VS Code的AI优先代码编辑器，免费版提供强大的AI辅助编程功能。

## AI音视频工具

### Suno
AI音乐生成工具，免费版可生成多首歌曲，支持多种音乐风格和语言。

### CapCut（剪映）
字节跳动推出的视频编辑工具，免费版内置AI剪辑、自动字幕等功能。

## 使用建议

1. 不要过度依赖AI，保持独立思考
2. 注意数据隐私，不要在AI工具中输入敏感信息
3. 多尝试不同工具，找到最适合自己工作流的组合`,
    category: 'AI工具',
    author: '资源导航编辑',
    publishDate: '2026-08-05',
    readTime: '10分钟',
    tags: ['AI工具', '人工智能', '效率工具'],
    imageSeq: 'article-ai-tools',
  },
  {
    id: 'article-3',
    title: '免费商用字体终极指南：100+款中英文免费字体推荐',
    slug: 'free-commercial-fonts-guide',
    excerpt: '精选100+款可免费商用的中英文字体，包含思源系列、阿里巴巴系列、站酷系列等，附带使用许可说明和下载链接。',
    content: `字体是设计中最基础也最重要的元素之一。选择合适的字体可以让你的设计作品瞬间提升档次，但商用字体的授权费用往往不菲。

## 中文字体推荐

### 思源系列
Adobe与Google联合开发的思源系列字体是免费字体的标杆之作。

**思源黑体**：现代感十足的無襯线字体，支持简繁中文、日文、韩文，适合标题和正文使用。

**思源宋体**：优雅的传统衬线字体，适合长文阅读和正式场合使用，字重丰富，排版效果出众。

### 阿里巴巴系列
**阿里巴巴普惠体**：涵盖多种字重的现代中文字体，适用于电商、品牌设计等多种商业场景。

**阿里妈妈数黑体**：专为电商数字显示优化的字体，数字部分设计独特，辨识度高。

### 站酷系列
站酷平台推出的多款免费商用字体各具特色：

- 站酷快乐体：圆润可爱，适合儿童、娱乐相关设计
- 站酷文艺体：手写风格，适合文艺、创意类设计
- 站酷小薇LOGO体：适合品牌标志设计

### 其他优秀中文字体
- 霞鹜文楷：基于Klee的开源中文字体，字形优美
- 优设标题黑：专为标题设计的粗黑体
- 庞门正道标题体：力量感十足的标题字体

## 英文字体推荐

### Google Fonts精选
- Inter：现代UI设计的首选字体
- DM Sans：几何感强，适合标题
- Playfair Display：优雅的衬线字体
- Space Grotesk：科技感十足

### 其他优秀英文字体
- JetBrains Mono：程序员最爱的等宽字体
- Public Sans：美国政府设计的通用字体
- Fira Code：支持连字的编程字体

## 使用注意事项

1. 下载前仔细阅读授权协议
2. 保留字体授权文件
3. 注意不同授权范围的限制
4. 定期检查字体版本更新`,
    category: '字体下载',
    author: '资源导航编辑',
    publishDate: '2026-07-20',
    readTime: '12分钟',
    tags: ['免费字体', '商用字体', '设计资源'],
    imageSeq: 'article-fonts-guide',
  },
  {
    id: 'article-4',
    title: '从零开始建站：2026年最佳免费建站工具和资源合集',
    slug: 'free-website-building-tools-2026',
    excerpt: '全面梳理2026年免费建站工具生态，从域名注册到网站部署，从静态网站到动态应用，一站式建站资源指南。',
    content: `建立自己的网站曾经是技术人员才能做到的事情，但在2026年，即使没有编程基础，你也可以利用免费工具轻松搭建出专业水准的网站。

## 静态网站托管平台

### Vercel
前端开发者首选的部署平台，与GitHub无缝集成，自动构建部署，全球CDN加速，免费版功能足够个人和小团队使用。

### Netlify
老牌静态网站托管平台，提供表单处理、身份验证等附加功能，使用简单，文档完善。

### GitHub Pages
GitHub提供的免费静态网站托管服务，适合技术文档、个人博客等场景，完全免费无限制。

### Cloudflare Pages
Cloudflare推出的静态网站托管服务，依托全球网络，速度快，免费额度慷慨。

## 无代码建站平台

### Carrd
简单优雅的单页网站构建器，免费版可创建最多3个网站，适合个人简介、产品落地页等场景。

### Framer
设计优先的建站平台，提供丰富的免费模板，视觉效果好，适合追求设计感的项目。

### Webflow
专业级可视化建站工具，免费版功能强大，学习曲线适中，适合设计师转型建站。

## CMS内容管理系统

### WordPress.com
全球使用最广泛的CMS系统，免费版提供基础建站功能，插件生态丰富。

### Strapi
开源无头CMS，免费自托管版本功能完整，适合有一定技术基础的用户。

## 域名服务

### Freenom
提供免费顶级域名（.tk、.ml等），适合学习和测试用途。

### eu.org
提供免费的.eu.org子域名，稳定可靠，适合长期使用。

## 网站模板资源

### HTML5 UP
提供精美的免费HTML5模板，响应式设计，代码规范，适合快速搭建网站。

### Bootstrapmade
提供大量免费Bootstrap模板，设计现代，文档完善。

## SEO优化免费工具

### Google Search Console
谷歌官方搜索优化工具，免费且权威，必装。

### Bing Webmaster Tools
必应站长工具，功能不输Google Search Console。

## 建站建议

1. 先明确网站目的和目标用户
2. 选择适合自己技术水平的工具
3. 重视移动端适配
4. 关注网站加载速度
5. 持续优化SEO`,
    category: '建站资源',
    author: '资源导航编辑',
    publishDate: '2026-07-15',
    readTime: '15分钟',
    tags: ['建站', '免费工具', '网站开发'],
    imageSeq: 'article-website-building',
  },
  {
    id: 'article-5',
    title: '程序员必备：30个提升效率的免费在线开发工具',
    slug: 'free-dev-tools-for-programmers',
    excerpt: '为开发者精选30个免费在线工具，涵盖代码格式化、API测试、JSON处理、正则调试等场景，让开发效率翻倍。',
    content: `开发者的效率很大程度上取决于使用的工具。好的工具能帮你节省大量时间，让你专注于真正重要的事情——写出优秀的代码。

## 代码编辑与协作

### CodeSandbox
在线代码沙盒，支持React、Vue、Angular等主流框架的即时预览和协作编辑。

### StackBlitz
基于WebContainers的在线IDE，可在浏览器中运行完整的Node.js环境。

### Replit
全能型在线编程平台，支持50+种编程语言，内置AI编程助手。

## API开发与测试

### Hoppscotch
免费开源的API测试工具，界面简洁，功能强大，支持REST、GraphQL、WebSocket等协议。

### JSON Server
零代码创建REST API的假数据服务，30秒内即可拥有一个完整的REST API。

### Mockoon
本地API模拟工具，创建自定义的假数据端点，支持CRUD操作。

## JSON与数据处理

### JSON Hero
美观的JSON查看和编辑器，自动推断数据类型，支持JSON Path查询。

### Transform
在线数据转换工具，支持JSON到TypeScript接口、JSON Schema等多种转换。

### Quicktype
将JSON数据自动转换为多种编程语言的类型定义。

## 正则与文本工具

### Regex101
最强大的在线正则表达式测试工具，支持多种语言的正则引擎，实时解释匹配结果。

### CyberChef
"网络瑞士军刀"，支持数百种编码、加密、压缩、数据分析操作。

### Diffchecker
在线文本和代码比较工具，支持语法高亮，适合代码审查。

## 图片与设计工具

### Excalidraw
手绘风格的在线白板工具，适合架构图、流程图绘制。

### Carbon
将代码片段转换为精美的分享图片，支持多种主题和语言。

### Ray.so
类似Carbon的代码截图工具，由Raycast团队开发，界面更精致。`,
    category: '开发工具',
    author: '资源导航编辑',
    publishDate: '2026-07-10',
    readTime: '10分钟',
    tags: ['开发工具', '程序员', '效率提升'],
    imageSeq: 'article-dev-tools',
  },
  {
    id: 'article-6',
    title: '免费可商用图片网站大全：告别版权焦虑的设计素材指南',
    slug: 'free-commercial-image-sites',
    excerpt: '整理了20个高质量免费图片网站，所有图片均可免费商用，支持高清下载，涵盖摄影、插画、纹理等多种类型。',
    content: `在内容创作和设计工作中，图片版权问题一直是让人头疼的事情。使用未授权的图片可能导致法律纠纷和经济损失。幸运的是，现在有很多高质量的免费图片网站可以帮助你解决这个问题。

## 综合图库推荐

### Unsplash
全球最知名的免费图片平台，每天更新数千张高清图片，质量极高，支持商业用途且无需署名。搜索功能强大，分类细致。

### Pexels
与Unsplash并驾齐驱的免费图片平台，同时提供免费视频素材，质量同样出色，支持中文搜索。

### Pixabay
老牌免费图片网站，拥有超过260万张免费图片和视频，涵盖题材广泛，是设计师的常用资源库。

## 特定风格图库

### Burst（Shopify）
Shopify旗下的免费图库，特别适合电商场景，包含大量产品和生活方式类图片。

### FoodiesFeed
专注美食摄影的免费图库，图片质量高，适合餐饮、食品相关设计。

### Nappy
提供黑人、少数族裔为主体的高质量免费图片，致力于增加多元文化代表性。

## 插画与矢量素材

### unDraw
提供大量可自定义颜色的开源SVG插画，风格现代简约，非常适合网页和移动端界面。

### ManyPixels
每周更新的免费插画库，支持在线调整配色，提供SVG和PNG格式下载。

### Humaaans
独特的人物插画组件库，可自由组合不同的人物、姿势和场景，非常灵活。

## 纹理与背景素材

### Transparent Textures
提供丰富的透明纹理素材，可叠加在纯色背景上使用，增加设计层次感。

### Hero Patterns
SVG格式的重复背景图案生成器，可自定义颜色和透明度。

## 使用建议

1. 虽然这些网站标注免费商用，但仍建议下载时查看单个图片的具体授权
2. 涉及人物肖像的图片要注意肖像权问题
3. 商业场景使用前最好保留下载截图作为授权证明`,
    category: '图片视频',
    author: '资源导航编辑',
    publishDate: '2026-06-28',
    readTime: '8分钟',
    tags: ['免费图片', '商用图片', '素材资源'],
    imageSeq: 'article-image-sites',
  },
];

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug);
};

export const getArticleById = (id: string) => {
  return articles.find((a) => a.id === id);
};

export const getLatestArticles = (limit: number = 4) => {
  return [...articles]
    .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())
    .slice(0, limit);
};